import styled from 'styled-components';
import { media } from 'helpers/breakpoints';
import { MediaHighlight } from 'components/Toolkit/Tags/MediaHighlight';
import { withOpacity } from 'helpers/Theme/Theme';

const Wrapper = styled.div<{
  isClickable: boolean;
  isDisabled: boolean;
  hasWhiteBackground: boolean;
}>`
  position: relative;
  cursor: ${({ isDisabled, isClickable }) => {
    if (!isDisabled && isClickable) return 'pointer';
    else if (!isDisabled && !isClickable) return 'auto';
    else return 'not-allowed';
  }};
  display: flex;
  background-color: ${({ theme, hasWhiteBackground }) =>
    hasWhiteBackground ? theme.colors.WHITE : theme.colors.GREY_LIGHTER};
  flex-direction: column;
  ${media.medium} {
    max-height: 430px;
    flex-direction: row;
  }
`;

const MainWrapper = styled.div<{ hasCarousel: boolean }>`
  display: flex;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
  position: relative;

  flex-direction: row;

  ${media.medium} {
    flex-direction: row;
    flex: ${({ hasCarousel }) => (hasCarousel ? '0 0 75%' : '0 0 100%')};
  }
`;

export const ContainerImage = styled.div<{ simpleImage: boolean }>`
  width: 100%;
  height: 426px;
  display: flex;

  @media (min-width: 0px) and (max-width: 320px) {
    height: 240px;
  }

  @media (min-width: 320px) and (max-width: 360px) {
    height: 270px;
  }

  @media (min-width: 360px) and (max-width: 428px) {
    height: 320px;
  }

  @media (min-width: 428px) and (max-width: 640px) {
    height: 480px;
  }
`;

const MainImage = styled.img<{ simpleImage: boolean }>`
  height: 100%;
  width: 100%;
  object-fit: cover;

  ${media.medium} {
    max-height: 100%;
    object-fit: ${({ simpleImage }) => (simpleImage ? 'contain' : 'cover')};
  }
`;

const ListWrapper = styled.div`
  display: flex;
  gap: 8px;
  ${media.medium} {
    display: inline-block;
    padding-left: 8px;
  }
`;

const ListImage = styled.div`
  position: relative;
  width: calc(33.33333333%);
  margin-top: 8px;

  ${media.medium} {
    height: calc(33.33333333% - 5.333px);
    margin-bottom: 8px;
    margin-top: 0px;
    width: auto;
    max-height: fit-content;
  }

  @media (min-width: 0px) and (max-width: 320px) {
    height: 78px;
  }

  @media (min-width: 320px) and (max-width: 360px) {
    height: 88px;
  }

  @media (min-width: 360px) and (max-width: 428px) {
    height: 105px;
  }

  @media (min-width: 428px) and (max-width: 640px) {
    height: 157px;
  }
`;

const OverlayImage = styled.img`
  height: 100%;
  max-height: 100%;
  max-width: 100%;
  width: 100%;
  object-fit: cover;
`;

const OverlayContent = styled.div<{ opacity: boolean }>`
  position: absolute;
  ${({ theme, opacity }) =>
    opacity && `background-color: ${withOpacity(theme.colors.BLACK)}}`};
  width: 100%;
  height: 100%;
  display: flex;
  align-content: center;
  justify-content: center;
  flex-wrap: nowrap;
  align-items: center;
  color: white;
`;

const ImageCounter = styled.span`
  ${({ theme }) => theme.fontSize.H24};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`;

const WatchVideo = styled.div`
  position: absolute;
  width: 100%;
  display: flex;
  align-content: center;
  justify-content: center;
  flex-wrap: nowrap;
  align-items: center;
  color: white;
  height: auto;
`;

const WatchReview = styled(MediaHighlight)`
  position: absolute;
  left: ${({ theme }) => theme.spacing.M16};
  bottom: ${({ theme }) => theme.spacing.M16};
  padding: ${({ theme }) => theme.spacing.S4} ${({ theme }) => theme.spacing.S8};
  background: rgba(34, 40, 49, 0.8);
  box-shadow: ${({ theme }) => theme.shadow.CONTAINER};

  span {
    display: inline-block;
    margin-left: 0.25em;
    ${({ theme }) => theme.fontSize.B12};
    font-weight: ${({ theme }) => theme.fontWeight.bold};
  }
`;

const YouTubeIcon = styled.img`
  height: 64px;
  width: 64px;
`;

export {
  MainWrapper,
  ListWrapper,
  ListImage,
  OverlayImage,
  OverlayContent,
  MainImage,
  Wrapper,
  WatchReview,
  ImageCounter,
  WatchVideo,
  YouTubeIcon,
};
